export default __webpack_public_path__ + "static/media/vectorImg.52aa5800.svg";